<template>
  <div>
    <headers :tabIndex="1"></headers>
    <div class="banner-box" :style="{'background-image':'url('+obj.cover+')'}">
      <div class="title">项目介绍</div>
      <div class="digest">{{obj.digest}}</div>

    </div>

    <div class="content" v-html="obj.h5Content">
    </div>
    <footers></footers>
  </div>
</template>


<script>
  import headers from "@/components/wap/header1"
  import footers from "@/components/wap/footer"
  import axios from "axios";
  export default {
    name: 'wapCaseDetail',
    components:{headers,footers},
    data() {
      return{
        obj:{},
      }
    },
    mounted() {
      this.id = this.$route.query.id;
      this.getcaseDetail()
    },
    beforeDestroy() {
    },
    methods:{
      getcaseDetail(){
        axios.get(this.pageUrl+`/project-case/${this.id}`).then(res=>{
          this.obj=res.data.data;
        })
      },
    }
  }
</script>
<style>
  .content img{
    width: 100% !important;
    object-fit: cover;
  }
</style>

<style scoped>
  .banner-box{
    width: 100%;
    height: 10rem;
    background: #0D0D2B;
    border-radius: 0px 0px 0px 0px;
    box-sizing: border-box;
    padding-top: 1rem;
    background-size: cover;
  }
  .banner-box .title{
    font-size: 0.32rem;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    color: #FFFFFF;
    width: 5.52rem;
    margin: 1rem auto 0;
  }
  .digest{
    font-size: 0.28rem;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    letter-spacing: 2px;
    line-height: 2;
    width: 5.52rem;
    margin: 0.4rem auto;
  }
  .content{
    width: 100%;
    padding: 0.2rem 0.4rem;
    box-sizing: border-box;
    margin-top: 0.4rem;
  }
</style>



// WEBPACK FOOTER //
// src/view/case/wapDetail.vue